module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"join-error":"Não foi possível ligar seu perfil a este acervo.","join-error-already-joined":"Você já segue este acervo","join-success":"Você se ligou a este acervo com sucesso!"}}')
  delete Component.options._Ctor
}
